import { CoursesIcon, Select, SelectOptionType, Table, useDefaultSorting } from '@bp/ui-components';
import { FragmentType } from 'client/gql';
import { OrganizationConfigContext } from 'context/OrganizationConfigContext';
import { useContext } from 'react';
import { SingleValue } from 'react-select';
import { UseCoursesTableFragment, useCoursesTable } from '../hooks/useCoursesTable';
import { CourseTableType } from '../types/types';

type CoursesStudentTableProps = {
  query: FragmentType<typeof UseCoursesTableFragment> | undefined;
  yearUuid: string;
  onYearSelect: (yearUuid: string) => void;
  onNavigate: (uuid: string) => void;
};

export const CoursesStudentTable = ({ query, yearUuid, onYearSelect, onNavigate }: CoursesStudentTableProps) => {
  const { schoolyears } = useContext(OrganizationConfigContext);

  const { data, columns } = useCoursesTable({
    query,
    showCourseInfo: true,
    columns: ['name', 'schoolYear'],
    onNavigate,
  });

  const { sorting, onSortingChange } = useDefaultSorting();

  const schoolYearOptions: SelectOptionType[] =
    schoolyears?.map(({ name, uuid }) => {
      return {
        label: name,
        value: uuid,
      };
    }) ?? [];

  return (
    <Table<CourseTableType>
      data={data}
      columns={columns}
      data-cy='courseList'
      canScroll
      showSort
      sorting={sorting}
      onSortingChange={onSortingChange}
      showActionBar
      actionBarSettings={{
        extendedActionsRight: (
          <div style={{ width: '136px' }}>
            <Select
              value={schoolYearOptions.find((y) => y.value === yearUuid)}
              options={schoolYearOptions}
              onChange={(option) => {
                onYearSelect((option as SingleValue<SelectOptionType>)?.value as string);
              }}
              name='school-year-select'
              dense
            />
          </div>
        ),
      }}
      isOnWhite={false}
      hideHeader={data.length === 0}
      showBorderRadius
      showShadow
      emptyStateSettings={{
        icon: <CoursesIcon className='svg-icon primary-light' />,
        padding: 'xl',
      }}
    />
  );
};
